fragment UsageScorecardEntry on UsageScorecardEntry {
    currentUsage
    planLimit
    customLimit
    displayName
}
